import { S } from './Link.styles';
import type { ExternalLinkProps, LinkProps } from './Link.types';

/**
 * Interne Links ohne Prefetch. Passwort-Manager (beobachtet mit Keeper, 2026-09-30) veraendern auf
 * Seiten mit Eingabefeldern laufend das DOM, und next/link feuerte dadurch den Prefetch der
 * Link-Ziele im Sekundentakt (1.391 Requests in 90 s aus einem Tab, im Inkognito-Fenster nicht
 * reproduzierbar). Das Portal hat wenige Seiten, die aus dem Cache in Millisekunden antworten;
 * ein Vorladen bringt kaum etwas. Gilt auch fuer JobPost (Karte) und LinkButton.
 */
export const Link = ({ prefetch = false, ...props }: LinkProps) => <S.Link prefetch={prefetch} {...props} />;

export const ExternalLink = (props: ExternalLinkProps) => <S.ExternalLink {...props} />;
